import React from 'react';
import { ProjectCostsKpiRow } from './ProjectCostsKpiRow';
import { ProjectCostsHeader } from './ProjectCostsHeader';
import { ProjectCostsList } from './ProjectCostsList';
import { ProjectCostsSidebar } from './ProjectCostsSidebar';
import { useProjectCosts } from '../hooks/useProjectCosts';

export function ProjectCostsMain() {
  const { data, isLoading } = useProjectCosts();

  if (isLoading) {
    return <div className="p-10 text-center text-slate-400">Đang tải dữ liệu chi phí...</div>;
  }

  return (
    <div className="space-y-6">
      {/* Hàng KPI Tài chính */}
      <ProjectCostsKpiRow kpis={data.kpis} />

      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
        {/* Nội dung chính: Danh sách chi phí */}
        <div className="xl:col-span-9 space-y-6">
          <ProjectCostsHeader />
          <ProjectCostsList costItems={data.costItems} />
        </div>

        {/* Sidebar: Thống kê & Xu hướng */}
        <div className="xl:col-span-3">
          <ProjectCostsSidebar data={data} />
        </div>
      </div>
    </div>
  );
}
